import { render, staticRenderFns } from "./MoveFab.vue?vue&type=template&id=1d3f7679&lang=pug&"
import script from "./MoveFab.vue?vue&type=script&lang=js&"
export * from "./MoveFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MoveFab.vue"
export default component.exports